export const URI = ""; //"https://localhost:5043"
export const HZ_AUTH_COOKIE_KEY = "hz-auth";
export const HZ_SCOPE_COOKIE_KEY = "hz-scope";
export const RETURN_URL_QUERY_KEY = "ReturnUrl";
export const LOGIN_PATH = "/signin";
